import React from "react";
import { PlayCircle, Eye, ArrowRight, CheckCircle2, Rocket } from "lucide-react";

// Progress + Stage badges rendered from a display state object produced by
// getAuditDisplayState(audit). Colours come from the state so we don't need
// a global CSS map. testIds are stable across views.

export function ProgressBadge({ progress, testId = "progress-badge" }) {
  if (!progress) return null;
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center px-2 py-0.5 rounded-sm text-[10px] font-bold uppercase tracking-[0.08em] border"
      style={{ background: progress.bg, color: progress.fg, borderColor: progress.border }}
    >
      {progress.label}
    </span>
  );
}

export function StageChip({ stage, testId = "stage-badge" }) {
  if (!stage) return null;
  const map = {
    sky:     { bg: "#E0F2FE", fg: "#075985", border: "#7DD3FC" },
    indigo:  { bg: "#E0E7FF", fg: "#3730A3", border: "#A5B4FC" },
    emerald: { bg: "#D1FAE5", fg: "#065F46", border: "#6EE7B7" },
  };
  const c = map[stage.tone] || map.sky;
  return (
    <span
      data-testid={testId}
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-sm text-[10px] font-bold uppercase tracking-[0.08em] border"
      style={{ background: c.bg, color: c.fg, borderColor: c.border }}
    >
      {stage.short}
    </span>
  );
}

export function CtaIcon({ icon, size = 12, className = "" }) {
  if (icon === "eye") return <Eye size={size} className={className} />;
  if (icon === "start-post") return <Rocket size={size} className={className} />;
  return <PlayCircle size={size} className={className} />;
}
